/* eslint-disable no-undef */
import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";

@Component({
    selector: 'feeder-live-header-selector',
    template: require('./feeder-live-header-selector.component.html'),
})
export class FeederLiveHeaderSelectorComponent implements OnInit {

    formControlSelectHeader = new FormControl("default")

    @Input() headers!: string[];
    @Output() headersChange = new EventEmitter()

    ngOnInit(): void {
        this.formControlSelectHeader.valueChanges.subscribe(
            val => {
                if (val === 'default') {
                    return this.headersChange.emit(['bid', 'ask', 'last', 'close', 'change', 'change_percent', 'time']);
                } else {
                    return this.headersChange.emit(['bid', 'ask', 'last', 'vwap', 'id3', 'close', 'change', 'change_percent', 'time']);
                }
            }
        )
    }



}
